import React from 'react';

import { PERIOD_ALL_TIME, PERIOD_CUSTOM, PERIOD_LAST_MONTH, PERIOD_THIS_MONTH, PERIOD_THIS_QUARTER, PERIOD_THIS_YEAR } from '../time_report/timeReportFormat';

import Button from 'CommonComponents/Button';
import CheckboxInput from 'CommonComponents/CheckboxInput';
import SegmentedControl from 'CommonComponents/SegmentedControl';
import SelectInput from 'CommonComponents/SelectInput';

export const STATUS_ALL = 'all';
export const STATUS_ACTIVE = 'active';
export const STATUS_CLOSED = 'closed';

const STATUS_OPTIONS = () => [
    { value: STATUS_ALL, label: $t('All') },
    { value: STATUS_ACTIVE, label: $t('Active') },
    { value: STATUS_CLOSED, label: $t('Closed') },
];

const PERIOD_OPTIONS = () => [
    { value: PERIOD_ALL_TIME, label: $t('All time') },
    { value: PERIOD_THIS_MONTH, label: $t('This month') },
    { value: PERIOD_LAST_MONTH, label: $t('Last month') },
    { value: PERIOD_THIS_QUARTER, label: $t('This quarter') },
    { value: PERIOD_THIS_YEAR, label: $t('This year') },
    { value: PERIOD_CUSTOM, label: $t('Custom range') },
];

/**
 * Period, Status, the no-time toggle and Export, and deliberately nothing else. The per-project
 * report's grouping and type controls have no meaning over a set of projects,
 * and this report carries no drill-through for them to narrow.
 */
export default function TimeOverviewFilters({ filters, onChange, onExport }) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-4">
            <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-x-6 tw-gap-y-3">
                <div>
                    <label htmlFor="time_overview_period" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                        {$t('Period')}
                    </label>
                    <SelectInput
                        id="time_overview_period"
                        name="time_overview_period"
                        value={filters.period}
                        onChange={(event) => onChange({ period: event.target.value })}
                    >
                        {PERIOD_OPTIONS().map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </SelectInput>
                </div>

                <div>
                    <span id="time_overview_status_label" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                        {$t('Status')}
                    </span>
                    <div aria-labelledby="time_overview_status_label">
                        <SegmentedControl variant="track" options={STATUS_OPTIONS()} value={filters.status} onChange={(status) => onChange({ status })} />
                    </div>
                </div>

                {filters.period === PERIOD_CUSTOM && (
                    <>
                        <div>
                            <label htmlFor="time_overview_from" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                                {$t('From')}
                            </label>
                            <input
                                id="time_overview_from"
                                type="date"
                                value={filters.from || ''}
                                max={filters.to || undefined}
                                onChange={(event) => onChange({ from: event.target.value })}
                                className="tw-border-2 tw-border-grey tw-rounded-lg tw-text-sm tw-p-1.5"
                            />
                        </div>
                        <div>
                            <label htmlFor="time_overview_to" className="tw-block tw-text-xs tw-text-charcoal-50 tw-mb-1">
                                {$t('To')}
                            </label>
                            <input
                                id="time_overview_to"
                                type="date"
                                value={filters.to || ''}
                                min={filters.from || undefined}
                                onChange={(event) => onChange({ to: event.target.value })}
                                className="tw-border-2 tw-border-grey tw-rounded-lg tw-text-sm tw-p-1.5"
                            />
                        </div>
                    </>
                )}

                <div className="tw-pb-2 tw-text-sm">
                    <CheckboxInput
                        id="time_overview_show_empty"
                        checked={filters.showEmpty}
                        onChange={(event) => onChange({ showEmpty: event.target.checked })}
                        label="Show projects with no time recorded"
                    />
                </div>
            </div>

            <Button variant="secondary" onClick={onExport}>
                {$t('Export')}
            </Button>
        </div>
    );
}
